<section class="reset-password">
  <form
    class="container type--xs reset-password__container"
    [formGroup]="forgotPasswordForm"
    *ngIf="!result || (result && !result.Succeeded)"
    (submit)="resetPassword(forgotPasswordForm.value)"
  >
    <h1 class="reset-password__title">Create a new password</h1>
    <span class="reset-password__subtitle"
      >Please enter your new password below.</span
    >

    <mat-form-field class="full--width">
      <input
        matInput
        type="password"
        placeholder="New password"
        formControlName="password"
      />
    </mat-form-field>

    <mat-form-field class="full--width">
      <input
        matInput
        type="password"
        placeholder="Confirm password"
        formControlName="passwordVerify"
      />
    </mat-form-field>

    <p class="error-message type--inverse" *ngIf="result && !result.Succeeded">
      <span *ngIf="result.Errors">{{ result.Errors[0]?.Description ?? 'An unknown error occured, please try again or request a new password.' }}</span>
      <span *ngIf="!result.Errors"
        >An unknown error occured, please try again or request a new
        password.</span
      >
    </p>
    <div class="reset-password__toolbar">
      <button
        class="button reset-password__toolbar__button"
        [disabled]="forgotPasswordForm.invalid || !passwordsEqual"
        [class.is--loading]="loading"
      >
        Save
      </button>
      <a [routerLink]="'/login'" class="link reset-password__toolbar__button"
        >Back to login</a
      >
    </div>
  </form>

  <div
    class="container type--xs forgot-password__container"
    *ngIf="result && result.Succeeded"
  >
    <h1 class="forgot-password__title">All done!</h1>
    <span class="forgot-password__subtitle"
      >Your password has succesfully been reset. You can now log in using your
      new password.</span
    >
    <div class="forgot-password__toolbar">
      <a [routerLink]="'/login'" class="link forgot-password__toolbar__button"
        >Back to login</a
      >
    </div>
  </div>
</section>
